import AuthTemplateWrapper from './AuthTemplateWrapper'

export default AuthTemplateWrapper
